const rawConsoleLog = console.log;
const rawConsoleError = console.error;
const rawConsoleInfo = console.info;

console.log = function () {
  if (process.env.STAGING_ENV === 'production') return;
  rawConsoleLog.apply(null, arguments);
};

console.error = function () {
  if (process.env.STAGING_ENV === 'production') return;
  rawConsoleError.apply(null, arguments);
};

console.info = function () {
  if (process.env.STAGING_ENV === 'production') return;
  rawConsoleInfo.apply(null, arguments);
};
